var _rect, _rect2, _circle, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMoreSliders = function SvgMoreSliders(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    height: 1.8,
    rx: 0.9,
    width: 18,
    x: 3,
    y: 6.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    height: 1.8,
    rx: 0.9,
    width: 10,
    x: 3,
    y: 11.1
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.2,
    cy: 12,
    r: 2.2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    height: 1.8,
    rx: 0.9,
    width: 18,
    x: 3,
    y: 16.1
  })));
};
export default SvgMoreSliders;